import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AccountService } from '@supoui/core/auth/account.service';
import { SidenavService } from '@supoui/core/services/sidenav.service';
import moment from 'moment';
import { PageType } from '@supoui/shared/components/info-bar/info-bar.component';

@Component({
    selector: 'header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class HeaderComponent implements OnInit {
  lastPage = PageType.LAST_PAGE;
  constructor(private accountService: AccountService, private sidenavService: SidenavService) {}

  ngOnInit(): void {}

  toggleSidenav(): void {
    this.sidenavService.toggle();
  }

  showSnow(): boolean {
    return [0, 11].includes(moment().month()) && this.isAuthenticated();
  }

  private isAuthenticated(): boolean {
    return this.accountService.isAuthenticated();
  }
}
